import searchTime from '../components/components-items/search-time.vue';
// 为组件添加 install 方法，用于按需引入
searchTime.install = function (Vue) {
    Vue.component(searchTime.name, searchTime)
}
export default searchTime